import { keyBy } from 'utils/arrayUtils';
import { IntegrationSettingsForm, IntegrationSettingsLevel, IntegrationSettingsTableDataByLevel } from '../types';
import { integrationSettingsDataKeyByLevel } from '../constants';

export const getIntegrationSettingsDialogFormData = (
  tableDataByLevel: IntegrationSettingsTableDataByLevel
): IntegrationSettingsForm => {
  return Object.keys(tableDataByLevel).reduce((formData: any, key) => {
    const typedKey = key as IntegrationSettingsLevel;
    const tableData = tableDataByLevel[typedKey] || [];
    formData[typedKey] = keyBy(tableData, integrationSettingsDataKeyByLevel[typedKey]);
    return formData;
  }, {});
};
